import FuseScrollbars from '@fuse/core/FuseScrollbars';
import AppBar from '@mui/material/AppBar';
import Hidden from '@mui/material/Hidden';
import Icon from '@mui/material/Icon';
import { useTheme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import Logo from 'app/fuse-layouts/shared-components/Logo';
import NavbarFoldedToggleButton from 'app/fuse-layouts/shared-components/NavbarFoldedToggleButton';
import NavbarMobileToggleButton from 'app/fuse-layouts/shared-components/NavbarMobileToggleButton';
import Navigation from 'app/fuse-layouts/shared-components/Navigation';
import UserNavbarHeader from 'app/fuse-layouts/shared-components/UserNavbarHeader';
import clsx from 'clsx';
import React from 'react';

const useStyles = makeStyles(theme => ({
	content: {
		overflowX: 'hidden',
		overflowY: 'auto',
		'-webkit-overflow-scrolling': 'touch'
		// background:
		// 	'linear-gradient(rgba(0, 0, 0, 0) 30%, rgba(0, 0, 0, 0) 30%), linear-gradient(rgba(0, 0, 0, 0.25) 0, rgba(0, 0, 0, 0) 40%)',
		// backgroundRepeat: 'no-repeat',
		// backgroundSize: '100% 40px, 100% 10px',
		// backgroundAttachment: 'local, scroll'
	},
	appBar: {
		background: `linear-gradient(90deg, #204321 0%, ${theme.palette.secondary.main} 64px)`
	}
}));

function NavbarLayout1(props) {
	const classes = useStyles();
	const theme = useTheme();

	return (
        <div className={clsx('flex flex-col overflow-hidden h-full', props.className)}>
			<AppBar
				color="primary"
				position="static"
				elevation={0}
				className={clsx('flex flex-row items-center flex-shrink h-64 min-h-64 pl-12 pr-2', classes.appBar)}
			>
				<div className="flex flex-1 mx-4">
					<Logo link />
				</div>

				<Hidden lgDown>
					<NavbarFoldedToggleButton className="w-40 h-40 p-0" />
				</Hidden>

				<Hidden lgUp>
					<NavbarMobileToggleButton className="w-40 h-40 p-0">
						<Icon>{theme.direction === 'ltr' ? 'arrow_back' : 'arrow_forward'}"</Icon>
					</NavbarMobileToggleButton>
				</Hidden>
			</AppBar>

			<FuseScrollbars className={clsx(classes.content)} option={{ suppressScrollX: true }}>
				{/* <UserNavbarHeader /> */}

				<Navigation layout="vertical" />
			</FuseScrollbars>
		</div>
    );
}

export default React.memo(NavbarLayout1);
